/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { Log } from '../logging/Log';

export class MessageService {
    public static CCB_OVERRIDDEN_SWITCHES: string = 'KaveriApp.BackdoorEntry.getCcbOverriddenSwitches';

    public static CCB_SWITCH_PARTNER: string = 'KaveriApp.BackdoorEntry.getCcbSwitchPartner';

    public static CCB_SWITCH_VERSION: string = 'KaveriApp.BackdoorEntry.getCcbSwitchVersion';

    public static CLOSE_APPLICATION: string = 'KaveriApp.DeviceModel.closeApplication';

    public static DISABLE_SCREENSAVER: string = 'KaveriApp.DeviceModel.disableScreenSaver';

    public static ENABLE_SCREENSAVER: string = 'KaveriApp.DeviceModel.enableScreenSaver';

    public static GET_APP_ENVIRONMENT: string = 'KaveriApp.DeviceModel.getAppEnvironment';

    public static GET_FLAVOUR: string = 'KaveriApp.DeviceModel.getFlavour';

    public static GET_SYSTEM_INFO: string = 'KaveriApp.DeviceModel.getSystemInfo';

    public static GET_TV_PROPERTIES: string = 'KaveriApp.DeviceModel.getTVProperties';

    public static GET_TIVO_SETTINGS: string = 'KaveriApp.DeviceModel.getTiVoSettings';

    public static LAUNCH_SYSTEM_SETTING: string = 'KaveriApp.DeviceModel.launchSystemSetting';

    public static RESTART_APPLICATION: string = 'KaveriApp.DeviceModel.restartApplication';

    private payload: Object = {};

    private serviceName: string = '';

    private serviceTimeoutId: any = null;

    private TAG = 'MessageService';

    constructor(serviceName, serviceArgs?) {
        this.serviceName = serviceName;
        this.payload = {
            type: 'messageServiceRequest',
            serviceName,
            serviceArgs,
        };
    }

    getResponse = () => {
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line consistent-return
            window.addEventListener('message', (event) => {
                const data = event?.data;
                if (window.self === window.top) return resolve(true);

                if (
                    data.type !== 'messageServiceResponse' ||
                    data.serviceName !== this.serviceName
                ) {
                    // eslint-disable-next-line consistent-return
                    return;
                }

                if (
                    data.type === 'messageServiceResponse' &&
                    data.serviceName === this.serviceName
                ) {
                    clearTimeout(this.serviceTimeoutId);
                    return resolve(data.response);
                }

                this.serviceTimeoutId = setTimeout(() => {
                    Log.e(this.TAG, `Service timeout ${this.serviceName}`);
                    return reject(new Error(`Service timeout ${this.serviceName}`));
                }, 3000);
            });
            window.parent.postMessage(this.payload, '*');
        });
    };
}
